import React, { useEffect, useState } from "react";
import { BaseModal } from "./BaseModal";
export const ConnectingWalletModal = ({ isOpen, classNames, renderLoader, reset, ...props }) => {
    const [showHelp, setShowHelp] = useState(false);
    // Show help if timeout is reached.
    useEffect(() => {
        if (!isOpen) {
            setShowHelp(false);
            return;
        }
        const timeout = setTimeout(() => setShowHelp(true), 5000);
        return () => clearTimeout(timeout);
    }, [isOpen, setShowHelp]);
    return (React.createElement(BaseModal, { classNames: classNames, isOpen: isOpen, maxWidth: "24rem", title: "Connecting wallet...", ...props },
        showHelp && (React.createElement("p", { className: classNames?.textContent },
            "If nothing shows up in your wallet,",
            " ",
            React.createElement("button", { onClick: reset, style: { textDecoration: "underline", display: "inline" } }, "click here to reset"),
            " ",
            "and try connecting again. Refresh the page if the problem persists.")),
        renderLoader && React.createElement("div", { className: "mt-4" }, renderLoader())));
};
//# sourceMappingURL=ConnectingWalletModal.js.map